export const FURNITURE_INVENTORY_DATA = {
  "Living Room Furniture": [
    { id: "f1", name: "Sofa Set", price: 500 },
    { id: "f2", name: "TV Unit / Cabinet", price: 400 },
    { id: "f3", name: "Center Table", price: 150 },
    { id: "f4", name: "Shoe Rack", price: 100 },
    { id: "f5", name: "Bookshelf", price: 300 }
  ],
  "Bedroom Furniture": [
    { id: "f6", name: "Bed (Single/Double)", price: 600 },
    { id: "f7", name: "Mattress", price: 150 },
    { id: "f8", name: "Wardrobe / Cupboard", price: 800 },
    { id: "f9", name: "Dressing Table", price: 250 }
  ],
  "Dining & Study": [
    { id: "f10", name: "Dining Table", price: 500 },
    { id: "f11", name: "Chairs (Per Piece)", price: 50 },
    { id: "f12", name: "Study Table", price: 250 },
    { id: "f13", name: "Office Desk", price: 350 }
  ]
};